// src/pages/Workflows/Editor/components/nodes/WorkflowNodeComponent.js
// Componente React Flow para renderizar um nó no canvas

import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { NODE_DEFINITIONS, CATEGORIA_CORES } from '../../utils/nodeDefinitions';

const WorkflowNodeComponent = memo(({ data, selected }) => {
  const def = NODE_DEFINITIONS[data.nodeType];
  if (!def) return null;

  const cor = CATEGORIA_CORES[def.categoria] || '#64748b';

  // Para nós com inputs dinâmicos (ex: unificar_valores), usa config em vez de def
  const inputs = def.inputs_dinamicos
    ? (data.config?.params?.entradas || []).map(e => ({
        nome: e.input_nome,
        label: e.nome || e.input_nome,
        obrigatorio: false,
      }))
    : (def.inputs || []);

  return (
    <div
      className={`wf-node${selected ? ' wf-node--selected' : ''}`}
      style={{ borderColor: cor }}
    >
      {/* Handle de Output (direita) */}
      <Handle
        type="source"
        position={Position.Right}
        id="output"
        className="wf-handle wf-handle-output"
        style={{ background: cor }}
      />

      {/* Header do nó */}
      <div className="wf-node-header" style={{ background: cor }}>
        <span className="wf-node-categoria">{def.categoria}</span>
        <span className="wf-node-label">{def.label}</span>
      </div>

      {/* Campos de input */}
      {inputs.length > 0 && (
        <div className="wf-node-inputs">
          {inputs.map((inp, idx) => (
            <div key={inp.nome} className="wf-node-input-row">
              <Handle
                type="target"
                position={Position.Left}
                id={`input_${inp.nome}`}
                className="wf-handle wf-handle-input"
                style={{ top: `${40 + idx * 24}px` }}
              />
              <span className="wf-node-input-label">
                {inp.label || inp.nome}
                {inp.obrigatorio && <span style={{ color: '#ef4444' }}> *</span>}
              </span>
            </div>
          ))}
        </div>
      )}

      {/* Output type badge */}
      <div className="wf-node-footer">
        <span className="wf-node-output-type" style={{ background: cor + '22', color: cor }}>
          {def.outputType}
        </span>
      </div>
    </div>
  );
});

WorkflowNodeComponent.displayName = 'WorkflowNodeComponent';

export default WorkflowNodeComponent;
